import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Surface card container. Compose with CardHeader/CardBody/CardFooter. */
export function Card({ children, className, as: As = 'div' }: { children: ReactNode; className?: string; as?: 'div' | 'section' | 'article' }) {
  return <As className={cn('rounded-xl border border-border bg-surface', className)}>{children}</As>;
}

export function CardHeader({ title, description, actions, className }: {
  title?: ReactNode; description?: ReactNode; actions?: ReactNode; className?: string;
}) {
  return (
    <div className={cn('flex items-start justify-between gap-3 border-b border-border px-5 py-4', className)}>
      <div>
        {title && <h3 className="text-sm font-semibold text-fg">{title}</h3>}
        {description && <p className="mt-0.5 text-sm text-fg-muted">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-5', className)}>{children}</div>;
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('flex items-center justify-end gap-2 border-t border-border px-5 py-3', className)}>{children}</div>;
}
